import { render, staticRenderFns } from "./AccountOrderDetailsBackorderedGrid.vue?vue&type=template&id=44beeae9&"
import script from "./AccountOrderDetailsBackorderedGrid.vue?vue&type=script&lang=js&"
export * from "./AccountOrderDetailsBackorderedGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports